// removed by extract-text-webpack-plugin
module.exports = {"footer":"footer___3EQLU"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer.module.less
// module id = 748
// module chunks = 0